import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegDetailsComponent } from './details.component';
import { RegisterService } from 'src/app/services/register/register.service';
import { AlertListService, TranslateModule, LoaderModule } from '@xref/ngx';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [RegDetailsComponent],
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        LoaderModule
    ],
    exports: [RegDetailsComponent],
    providers: [
        RegisterService,
        AlertListService
    ],
})
export class RegDetailsModule {}
